import styled from 'styled-components'

export const Container = styled.div`
  position: fixed;
  top: 95px;
  left: 120px;
  z-index: 199;
  display: flex;
  gap: 12px;
  user-select: none;

  @media (max-width: 900px) {
    left: 10px;
    top: 85px;
    flex-direction: column;
    gap: 8px;
  }
`

export const SelectWrapper = styled.div`
  position: relative;
  min-width: 160px;
`

export const SelectToggle = styled.button<{ $open?: boolean }>`
  width: 100%;
  min-width: 160px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 0 16px;
  border: 1px solid #d5d8de;
  border-radius: 12px;
  background: #fff;
  color: #2c2c2c;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:hover:not(:disabled) {
    border-color: #afb5c5;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  }

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }
`

export const ArrowWrapper = styled.span<{ $open?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s ease;
  transform: rotate(${({ $open }) => ($open ? '180deg' : '0deg')});
`

export const OptionsList = styled.ul<{ $open?: boolean }>`
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  right: 0;
  margin: 0;
  padding: 8px;
  list-style: none;
  background: #fff;
  border: 1px solid #d5d8de;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  max-height: 280px;
  overflow-y: auto;
  z-index: 210;
  opacity: ${({ $open }) => ($open ? 1 : 0)};
  visibility: ${({ $open }) => ($open ? 'visible' : 'hidden')};
  transform: translateY(${({ $open }) => ($open ? '0' : '-4px')});
  transition: opacity 0.15s ease, transform 0.15s ease, visibility 0.15s ease;
`

export const OptionItem = styled.li`
  padding: 10px 12px;
  border-radius: 8px;
  font-size: 14px;
  color: #2c2c2c;
  cursor: pointer;

  &:hover {
    background: #f2f3f4;
  }
`
